// @flow

import React, { Component, Fragment, type ComponentType } from 'react';
import { connect } from 'react-redux';
import { Flex, Button } from 'clark-styles';

import { deleteSession } from 'actions/sessions';
import CancelButton from 'components/button-cancel';
import ModalAndTrigger from 'containers/modal-and-trigger';
import { type SessionType } from 'types/sessions';
import DeleteIcon from 'assets/icons/trash.svg';

import { generateHeadline, generateCopy } from './helpers';
import { Copy, Headline, SubmitButton, Wrapper, Cta } from './styles';
import RecurrenceGroupingButtons from './recurrence-grouping-buttons';

type PassedInPropsType = {
  session: SessionType,
  isButton?: boolean,
  disabled: boolean,
  deleteRecurringEnabled: boolean,
  remainingRecurringSessions: SessionType[],
};

type DispatchPropsType = {
  dispatchDeleteSession: typeof deleteSession,
};

type PropsType = PassedInPropsType & DispatchPropsType;

const mapDispatchToProps: DispatchPropsType = { dispatchDeleteSession: deleteSession };

const BUTTON_COPY = 'Delete Session';

const renderModalTrigger = (isButton, disabled, toggleModal) => (
  <Fragment>
    {isButton ? (
      <Button
        layout="fullWidth"
        styleType="outlineSecondary"
        disabled={disabled}
        icon={<DeleteIcon />}
        onClick={toggleModal}
      >
        {BUTTON_COPY}
      </Button>
    ) : (
      <Cta type="button" disabled={disabled} onClick={toggleModal}>
        {BUTTON_COPY}
      </Cta>
    )}
  </Fragment>
);

class SessionsDeleteModal extends Component<PropsType> {
  handleDeleteSession = ({ shouldUpdateFutureSessions }) => {
    const {
      session: { id: resourceId },
      dispatchDeleteSession,
    } = this.props;
    dispatchDeleteSession(resourceId, shouldUpdateFutureSessions);
  };

  render() {
    const { isButton, disabled, deleteRecurringEnabled, remainingRecurringSessions } = this.props;
    return (
      <ModalAndTrigger
        modalContentLabel="Delete-Session Modal"
        renderModalTrigger={toggleModal => renderModalTrigger(isButton, disabled, toggleModal)}
        renderModalContent={toggleModal => (
          <Wrapper>
            <Flex justifyContent="space-between">
              <Headline>{generateHeadline(deleteRecurringEnabled)}</Headline>
              <CancelButton onClick={toggleModal} />
            </Flex>
            <Copy>{generateCopy(deleteRecurringEnabled)}</Copy>
            {deleteRecurringEnabled ? (
              <RecurrenceGroupingButtons
                handleDeleteSession={this.handleDeleteSession}
                remainingRecurringSessions={remainingRecurringSessions}
              />
            ) : (
              <Flex justifyContent="center">
                <SubmitButton
                  type="button"
                  onClick={() => this.handleDeleteSession({ shouldUpdateFutureSessions: false })}
                  layout="fullWidth"
                >
                  Yes, delete and go back
                </SubmitButton>
              </Flex>
            )}
          </Wrapper>
        )}
      />
    );
  }
}

const Connected: ComponentType<PassedInPropsType> = connect(
  null,
  mapDispatchToProps,
)(SessionsDeleteModal);

export default Connected;



// WEBPACK FOOTER //
// ./src/containers/sessions/delete-modal/index.js